import React from "react";

import { NotificationPlaceholderStyled as Styles } from "./Notification.styles";
import { NotificationPlaceholderProps as Props } from "./Notification.types";

const NotificationPlaceholder: React.FC<Props> = props => {
  const { className } = props;

  return (
    <Styles className={`NotificationPlaceholder ${className}`}>
      <div className="NotificationPlaceholder__icon loading-shine" />
      <div className="NotificationPlaceholder__title loading-shine" />
      <div className="NotificationPlaceholder__description loading-shine" />
    </Styles>
  );
};

NotificationPlaceholder.defaultProps = { className: "" };

export default NotificationPlaceholder;
